import type { Hook } from 'phoenix_live_view';
import { pushPanelLoadEvent } from './push-panel-load';

/**
 * Pushes "load-sentiment-stats" when the target game id is set or changes.
 */
export const loadSentimentStats: Hook = {
  mounted() {
    pushPanelLoadEvent(this, 'load-sentiment-stats');
  },
  updated() {
    pushPanelLoadEvent(this, 'load-sentiment-stats');
  },
};
